import { Form, Formik } from 'formik'
import Header from 'components/headers/bulletins'
import FormikInput from 'components/formikFields/input'
import Num2persian from 'utilities/helper/num2Persian'
import { useState } from 'react'
import { Schema } from './utils'
import useAddBox from './hooks/useAddBox'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'store/redux'
import { toggleLast, toggleStage } from 'store/redux/moneyPoolBox'
import useSetLoans from './hooks/useSetLoans'
import { toggleSupportModal } from 'store/redux/sidebar'
import SupportModal from 'components/modals/supportModal'
import { NumericFormat } from 'react-number-format'

export default function ManagerRecords() {
    const store = useSelector((state: RootState) => state.MoneyPoolBoxAdd)
    const { state } = useLocation()
    const { mutate } = useAddBox()
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const { createdLoans } = useSetLoans()
    const { isOpenSupportModal } = useSelector(
        (state: RootState) => state.sideBarControler
    )
    return (
        <>
            <Formik
                initialValues={{
                    totalObligationManager: store?.totalObligationManager
                        ? store?.totalObligationManager
                        : '',
                    paidObligationManager: store?.paidObligationManager
                        ? store?.paidObligationManager
                        : '',
                    totalVariousDeposit: store?.totalVariousDeposit
                        ? store?.totalVariousDeposit
                        : '',
                    totalVariousCashouts: store?.totalVariousCashouts
                        ? store?.totalVariousCashouts
                        : '',
                }}
                validationSchema={Schema}
                onSubmit={async (values) => {
                    const payload: IAddBoxFirstManagerOrdersPayload = {
                        moneyPool: Number(store?.moneyPool),
                        poolShip: Number(store?.poolShipId),
                        to_be_paid_portion: Number(
                            values.totalObligationManager
                        ),
                        loans: createdLoans,
                        ...(values.totalVariousDeposit !== ''
                            ? {
                                  cashins: [
                                      {
                                          amount: Number(
                                              values.paidObligationManager
                                          ),
                                          type: 'cnp',
                                      },
                                      {
                                          amount: Number(
                                              values.totalVariousDeposit
                                          ),
                                          type: 'cnc',
                                      },
                                  ],
                              }
                            : {
                                  cashins: [
                                      {
                                          amount: Number(
                                              values.paidObligationManager
                                          ),
                                          type: 'cnp',
                                      },
                                  ],
                              }),
                        ...(values.totalVariousCashouts
                            ? {
                                  cashouts: [
                                      {
                                          amount: Number(
                                              values.totalVariousCashouts
                                          ),
                                          type: 'ctc',
                                      },
                                  ],
                              }
                            : { cashouts: [] }),
                    }
                    mutate(payload)
                }}
            >
                {({
                    submitForm,
                    values,
                    handleChange,
                    errors,
                    touched,
                    setFieldValue,
                }) => (
                    <Form>
                        <div className=" flex flex-col bg-main-bg">
                            <div className=" grow-0">
                                <Header title="سوابق مدیر صندوق" />
                            </div>
                            <div className=" grow">
                                <div className=" bg-white py-3 px-2 my-4 ">
                                    <p className=" text-center text-[#858585]">
                                        مجموع تعهدات مدیر صندوق
                                    </p>
                                    <div className=" mt-4">
                                        <p className=" text-sm my-2">
                                            مجموع تعهدات مدیر
                                            <span className=" text-red-1 mx-2">
                                                (اجباری)
                                            </span>
                                        </p>
                                        <NumericFormat
                                            customInput={FormikInput}
                                            thousandSeparator
                                            allowNegative={false}
                                            label=""
                                            name="totalObligationManager"
                                            placeholder="- - - - - - - -"
                                            className="text-sm font-normal"
                                            defaultValue={
                                                values.totalObligationManager
                                            }
                                            isGray
                                            secondaryTitle="| تومان "
                                            onValueChange={(values) => {
                                                const { value } = values
                                                setFieldValue(
                                                    'totalObligationManager',
                                                    value
                                                )
                                            }}
                                        />

                                        <p className=" text-sm my-1 mx-2">
                                            مجموع حق عضویت‌هایی که توسط مدیر
                                            باید پرداخت می‌شده
                                        </p>
                                        {values.totalObligationManager !==
                                            '' && (
                                            <span className=" text-xs text-blue-1 text-center w-full">
                                                {Num2persian(
                                                    Number(
                                                        values.totalObligationManager
                                                    ).toString()
                                                )}{' '}
                                                تومان
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className=" bg-white py-3 px-2 my-4 ">
                                    <p className=" text-center text-[#858585]">
                                        تعهدات پرداخت شده مدیر صندوق
                                    </p>
                                    <div className=" mt-4">
                                        <p className=" text-sm my-2">
                                            تعهدات پرداخت شده مدیر
                                            <span className=" text-red-1 mx-2">
                                                (اجباری)
                                            </span>
                                        </p>
                                        <NumericFormat
                                            customInput={FormikInput}
                                            thousandSeparator
                                            allowNegative={false}
                                            label=""
                                            name="paidObligationManager"
                                            placeholder="- - - - - - - -"
                                            className="text-sm font-normal"
                                            defaultValue={
                                                values.paidObligationManager
                                            }
                                            isGray
                                            secondaryTitle="| تومان "
                                            onValueChange={(values) => {
                                                const { value } = values
                                                setFieldValue(
                                                    'paidObligationManager',
                                                    value
                                                )
                                            }}
                                        />

                                        <p className=" text-sm my-1 mx-2">
                                            مجموع حق عضویت‌هایی که توسط مدیر
                                            صندوق پرداخت شده
                                        </p>
                                        {values.paidObligationManager !==
                                            '' && (
                                            <span className=" text-xs text-blue-1 text-center w-full">
                                                {Num2persian(
                                                    Number(
                                                        values.paidObligationManager
                                                    ).toString()
                                                )}{' '}
                                                تومان
                                            </span>
                                        )}
                                    </div>
                                </div>

                                <div className=" bg-white py-3 px-2 my-4 ">
                                    <p className=" text-center text-[#858585]">
                                        وام‌های دریافتی{' '}
                                        <span className=" text-red-1">
                                            (اجباری)
                                        </span>
                                    </p>
                                    <div className=" mt-4 px-2">
                                        <div className="mb-[0.125rem] flex ps-[1.5rem] my-2 items-center">
                                            <input
                                                className="relative -ms-[1.5rem] me-1 mt-0.5  rounded-full border-2 border-solid border-secondary-500 before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-checkbox before:shadow-transparent before:content-[''] after:absolute after:z-[1] after:block after:h-4 after:w-4 after:rounded-full after:content-[''] checked:border-green-1 checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 checked:after:h-[0.625rem] checked:after:w-[0.625rem] checked:after:rounded-full checked:after:border-green-1 checked:after:bg-green-1 checked:after:content-[''] checked:after:[transform:translate(-50%,-50%)] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-black/60 focus:shadow-none focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-black/60 focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:border-green-1 checked:focus:before:scale-100 checked:focus:before:shadow-checkbox checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] rtl:float-right dark:border-neutral-400 dark:checked:border-green-1"
                                                type="radio"
                                                name="flexRadioDefault"
                                                id="radioDefault01"
                                                onChange={() =>
                                                    dispatch(toggleStage(0))
                                                }
                                                checked={store.stage === 0}
                                            />
                                            <label
                                                className="mt-px  ps-[0.15rem] hover:cursor-pointer"
                                                htmlFor="radioDefault01"
                                            >
                                                وامی دریافت نکرده‌ام.
                                            </label>
                                        </div>
                                        <hr className=" my-2" />
                                        <div className="mb-[0.125rem] flex ps-[1.5rem] my-2 items-center">
                                            <input
                                                className="relative -ms-[1.5rem] me-1 mt-0.5  rounded-full border-2 border-solid border-secondary-500 before:pointer-events-none before:absolute before:h-4 before:w-4 before:scale-0 before:rounded-full before:bg-transparent before:opacity-0 before:shadow-checkbox before:shadow-transparent before:content-[''] after:absolute after:z-[1] after:block after:h-4 after:w-4 after:rounded-full after:content-[''] checked:border-green-1 checked:before:opacity-[0.16] checked:after:absolute checked:after:left-1/2 checked:after:top-1/2 checked:after:h-[0.625rem] checked:after:w-[0.625rem] checked:after:rounded-full checked:after:border-green-1 checked:after:bg-green-1 checked:after:content-[''] checked:after:[transform:translate(-50%,-50%)] hover:cursor-pointer hover:before:opacity-[0.04] hover:before:shadow-black/60 focus:shadow-none focus:outline-none focus:ring-0 focus:before:scale-100 focus:before:opacity-[0.12] focus:before:shadow-black/60 focus:before:transition-[box-shadow_0.2s,transform_0.2s] checked:focus:border-green-1 checked:focus:before:scale-100 checked:focus:before:shadow-checkbox checked:focus:before:transition-[box-shadow_0.2s,transform_0.2s] rtl:float-right dark:border-neutral-400 dark:checked:border-green-1"
                                                type="radio"
                                                name="flexRadioDefault"
                                                id="radioDefault01"
                                                onChange={() =>
                                                    dispatch(toggleStage(1))
                                                }
                                                checked={store.stage === 1}
                                            />
                                            <label
                                                className="mt-px  ps-[0.15rem] hover:cursor-pointer"
                                                htmlFor="radioDefault01"
                                            >
                                                وام دریافت کرده‌ام.
                                            </label>
                                        </div>
                                    </div>
                                    {store?.loans.length > 0 &&
                                        store.loans.map((item) => (
                                            <div
                                                key={item.id}
                                                className=" my-2 mx-2 flex justify-between py-1 px-1 rounded-lg items-center border-1 border-[#B7BEC7]"
                                            >
                                                <p>
                                                    {Number(
                                                        item.amount
                                                    ).toLocaleString()}{' '}
                                                    تومان
                                                </p>
                                                <div
                                                    onClick={() => {
                                                        dispatch(
                                                            toggleLast(values)
                                                        )
                                                        navigate('edit-loan', {
                                                            state: {
                                                                id: item.id,
                                                            },
                                                        })
                                                    }}
                                                    className=" text-white bg-green-1 rounded-lg py-2 px-4 text-center cursor-pointer"
                                                >
                                                    ویرایش
                                                </div>
                                            </div>
                                        ))}
                                    {store.stage === 1 && (
                                        <div className=" mx-2">
                                            <button
                                                className=" py-2 text-green-1 border-1 border-green-1 w-full rounded-lg my-2"
                                                onClick={() => {
                                                    dispatch(toggleLast(values))
                                                    navigate('new-loan')
                                                }}
                                            >
                                                + ثبت وام
                                            </button>
                                        </div>
                                    )}
                                </div>

                                <div className=" bg-white py-3 px-2 my-4 ">
                                    <p className=" text-center text-[#858585]">
                                        مجموع واریزی‌های متفرقه
                                    </p>
                                    <div className=" mt-4">
                                        <p className=" text-sm my-2">
                                            مجموع واریزی‌های متفرقه
                                        </p>
                                        <NumericFormat
                                            customInput={FormikInput}
                                            thousandSeparator
                                            allowNegative={false}
                                            label=""
                                            name="totalVariousDeposit"
                                            placeholder="- - - - - - - -"
                                            className="text-sm font-normal"
                                            defaultValue={
                                                values.totalVariousDeposit
                                            }
                                            isGray
                                            secondaryTitle="| تومان "
                                            onValueChange={(values) => {
                                                const { value } = values
                                                setFieldValue(
                                                    'totalVariousDeposit',
                                                    value
                                                )
                                            }}
                                        />

                                        {values.totalVariousDeposit !== '' && (
                                            <span className=" text-xs text-blue-1 text-center w-full">
                                                {Num2persian(
                                                    Number(
                                                        values.totalVariousDeposit
                                                    ).toString()
                                                )}{' '}
                                                تومان
                                            </span>
                                        )}
                                    </div>
                                </div>
                                <div className=" bg-white py-3 px-2 my-4 ">
                                    <p className=" text-center text-[#858585]">
                                        مجموع برداشت‌های متفرقه
                                    </p>
                                    <div className=" mt-4">
                                        <p className=" text-sm my-2">
                                            مجموع برداشت‌های متفرقه
                                        </p>
                                        <NumericFormat
                                            customInput={FormikInput}
                                            thousandSeparator
                                            allowNegative={false}
                                            label=""
                                            name="totalVariousCashouts"
                                            placeholder="- - - - - - - -"
                                            className="text-sm font-normal"
                                            defaultValue={
                                                values.totalVariousCashouts
                                            }
                                            isGray
                                            secondaryTitle="| تومان "
                                            onValueChange={(values) => {
                                                const { value } = values
                                                setFieldValue(
                                                    'totalVariousCashouts',
                                                    value
                                                )
                                            }}
                                        />

                                        {values.totalVariousCashouts !== '' && (
                                            <span className=" text-xs text-blue-1 text-center w-full">
                                                {Num2persian(
                                                    Number(
                                                        values.totalVariousCashouts
                                                    ).toString()
                                                )}{' '}
                                                تومان
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className=" grow-0">
                                <div className=" text-center my-4">
                                    <p>نیاز به راهنمایی دارید؟</p>
                                    <p
                                        className=" text-[#808080] underline"
                                        onClick={() =>
                                            dispatch(
                                                toggleSupportModal({
                                                    isOpenSupportModal: true,
                                                })
                                            )
                                        }
                                    >
                                        با مشاور همیان تماس بگیرید
                                    </p>
                                </div>
                                <div className=" bg-white py-4 px-4">
                                    <button className=" w-full bg-green-1 rounded-2xl text-white py-3">
                                        ادامه
                                    </button>
                                </div>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
            <SupportModal
                show={isOpenSupportModal}
                onHide={() =>
                    dispatch(toggleSupportModal({ isOpenSupportModal: false }))
                }
            />
        </>
    )
}
